<template>
  <div class="user-self">
    <Avator class="avator"></Avator>
    <div class="cards">
      <UpdatePwd></UpdatePwd>
      <ViperState></ViperState>
      <CommonToken></CommonToken>
      <Miniapp></Miniapp>
      <WebSetting></WebSetting>
      <Wechat></Wechat>
      <Mail></Mail>
      <Social></Social>
    </div>
  </div>
</template>

<script>
import Avator from "@/components/User/Self/Avator.vue";
import Social from "../../components/User/Self/Social.vue";
import UpdatePwd from "../../components/User/Self/UpdatePwd.vue";
import ViperState from "../../components/User/Self/VipStatus.vue";
import CommonToken from "../../components/User/Self/CommonToken.vue";
import Mail from "../../components/User/Self/Mail.vue";
import Miniapp from "../../components/User/Self/Miniapp.vue";
import WebSetting from "../../components/User/Self/WebSetting.vue";
import Wechat from "../../components/User/Self/Wechat.vue";
import { getUserInfo } from "@/api/user";

export default {
  name: "Self",
  components: {
    Avator,
    Social,
    UpdatePwd,
    ViperState,
    Miniapp,
    Mail,
    CommonToken,
    WebSetting,
    Wechat,
  },
  data() {
    return {};
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      getUserInfo().then((res) => {
        this.$store.commit("upUserInfo", res.data);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.user-self {
  display: flex;
  flex-direction: column;
  .avator {
    height: 300px;
  }
  .cards {
    display: flex;
    flex-shrink: 1;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .card {
      margin: 1rem;
      padding: 2rem;
      width: 30%;
      min-height: 300px;
      background: #fff;
    }
  }
}
</style>
